import { createReducer } from 'lib/utilities.js';
import jwtDecode from 'jwt-decode';
import { setToken } from '../../lib/authHelpers.js';

const initialState = {
  id: null,
  loggedIn: false,
  authentication: { token: null },
  profile: null,
  serviceProviderIds: [],
  resetPasswordData: {
    status: '',
    message: '',
    code: '',
  },
  requestPasswordEmailData: { status: '' },
  resetToken: null,
  invalidNotification: false,
  mercurePubSubToken: null,
};

export default createReducer(initialState, {
  LOGIN_SUCCESS: (state, payload) => {
    const jwt = jwtDecode(payload);
    return {
      ...state,
      id: jwt.user_id,
      authentication: {
        token: payload,
      },
      loggedIn: true,
      tresioUser: jwt.tresio_user === '1',
      serviceProviderIds: jwt.service_provider_ids || [],
      defaultTrackedPhoneId: jwt.default_tracked_phone_id,
      profile: {
        ...state.profile,
        first_name: jwt.first_name,
        last_name: jwt.last_name,
        email: jwt.email,
      },
    };
  },

  GET_USER_TOKEN_SUCCESS: (state, payload) => {
    let jwt = jwtDecode(payload.data.token);
    setToken(payload.data.token);
    return {
      ...state,
      id: jwt.user_id,
      authentication: {
        token: payload.data.token,
      },
      loggedIn: true,
      tresioUser: jwt.tresio_user === '1',
      serviceProviderIds: jwt.service_provider_ids || [],
      defaultTrackedPhoneId: jwt.default_tracked_phone_id || [],
      profile: {
        ...state.profile,
        first_name: jwt.first_name,
        last_name: jwt.last_name,
        email: jwt.email,
      },
    };
  },
  // Todo refactor into a fn. Duplicate code
  GET_IMPERSONATION_TOKEN_SUCCESS: (state, payload) => {
    let jwt = jwtDecode(payload.data.token);
    setToken(payload.data.token);
    return {
      ...state,
      id: jwt.user_id,
      authentication: {
        token: payload.data.token,
      },
      loggedIn: true,
      tresioUser: jwt.tresio_user === '1',
      serviceProviderIds: jwt.service_provider_ids || [],
      defaultTrackedPhoneId: jwt.default_tracked_phone_id || [],
      profile: {
        ...state.profile,
        first_name: jwt.first_name,
        last_name: jwt.last_name,
        email: jwt.email,
      },
    };
  },
  LOGOUT: (state) => initialState,

  GET_USER_PROFILE_SUCCESS: (state, payload) => ({
    ...state,
    profile: payload.data,
  }),

  GET_MERCURE_TOKEN_SUCCESS: (state, payload) => ({
    ...state,
    mercurePubSubToken: payload.data.token,
  }),

  DELETE_MERCURE_TOKEN: (state, payload) => ({
    ...state,
    mercurePubSubToken: null,
  }),

  POST_LOGIN_SUCCESS: (state, payload) => ({
    ...state,
    id: payload.data.user_id,
    authentication: {
      token: payload.data.token,
    },
    loggedIn: true,
    serviceProviderIds: payload.data.service_provider_ids || [],
    defaultTrackedPhoneId: payload.data.defaultTrackedPhoneId || [],
    tresioUser: payload.data.tresio_user === '1',
    profile: {
      ...state.profile,
      first_name: payload.data.first_name,
      last_name: payload.data.last_name,
      email: payload.data.email,
    },
  }),

  POST_LOGIN_FAIL: (state, payload) => ({
    ...state,
    invalidNotification: true,
  }),

  RESET_POST_LOGIN_FAIL: (state, payload) => ({
    ...state,
    invalidNotification: false,
  }),

  PATCH_USER_PROFILE_SUCCESS: (state, payload) => ({
    ...state,
    profile: {
      ...state.profile,
      ...payload.data,
    },
  }),

  POST_PASSWORD_RESET_EMAIL_SUCCESS: (state, payload) => ({
    ...state,
    requestPasswordEmailData: {
      ...payload,
    },
  }),

  DELETE_REQUEST_PASSWORD_EMAIL_DATA: (state, payload) => ({
    ...state,
    requestPasswordEmailData: {},
  }),

  POST_PASSWORD_RESET_SUCCESS: (state, payload) => ({
    ...state,
    resetPasswordData: {
      ...payload,
    },
  }),
});
